import React from "react";
import { Drawer } from "vaul";

/* Design-system bottom sheet for mobile/tablet — replaces side panels and
   dialogs below the `lg` breakpoint. Styled on the app's tokens (canvas,
   hairline) rather than the stock shadcn drawer so it reads as native chrome.

   `height`:
   - "auto" — hugs content (menus, small forms)
   - "tall" — 85dvh panel (config, settings), body scrolls inside */
export default function BottomSheet({ open, onOpenChange, title, height = "tall", children }: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: React.ReactNode;
  height?: "auto" | "tall";
  children?: React.ReactNode;
}) {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-50 bg-[var(--overlay)]" />
        <Drawer.Content
          className={`fixed inset-x-0 bottom-0 z-50 flex flex-col rounded-t-[16px] bg-[var(--canvas)] ring-1 ring-[var(--hairline)] shadow-[0_-8px_40px_rgba(0,0,0,0.18)] outline-none ${
            height === "tall" ? "h-[85dvh]" : "max-h-[85dvh]"
          }`}
        >
          {/* Grab handle */}
          <div className="shrink-0 pt-2.5 pb-1 flex justify-center">
            <div className="w-9 h-[4px] rounded-full bg-[var(--hairline-strong)]" />
          </div>
          {title ? (
            <Drawer.Title className="shrink-0 px-5 pb-2 text-[14px] font-semibold tracking-[-0.01em] text-[var(--text-primary)]">
              {title}
            </Drawer.Title>
          ) : (
            <Drawer.Title className="sr-only">Sheet</Drawer.Title>
          )}
          <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain pb-safe">{children}</div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
